function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from "react";
var usePhoneInput = function usePhoneInput(onMobileChange, data) {
  var defaultCountry = {
    name: "India",
    dialCode: "91",
    countryCode: "in",
    format: "+.. .....-....."
  };
  var _useState = useState(data || "91"),
    _useState2 = _slicedToArray(_useState, 2),
    mobile = _useState2[0],
    setMobile = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isValid = _useState4[0],
    setIsValid = _useState4[1];
  var _useState5 = useState(defaultCountry),
    _useState6 = _slicedToArray(_useState5, 2),
    country = _useState6[0],
    setCountry = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isInternationalCustomer = _useState8[0],
    setIsInternationalCustomer = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isInputFocused = _useState0[0],
    setInputFocused = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isTouched = _useState10[0],
    setIsTouched = _useState10[1];
  var mobileHasError = !isValid && isTouched;
  var getMobileWithoutCountryCode = function getMobileWithoutCountryCode() {
    if (country) {
      var _country$dialCode;
      return (mobile === null || mobile === void 0 ? void 0 : mobile.slice((_country$dialCode = country.dialCode) === null || _country$dialCode === void 0 ? void 0 : _country$dialCode.length)) || "";
    } else return null;
  };
  var onChange = function onChange(value, country) {
    if (country.dialCode != "91") {
      setIsInternationalCustomer(true);
    } else setIsInternationalCustomer(false);
    setCountry(country);
    setMobile(value);
    if (onMobileChange) {
      onMobileChange(value);
    }
  };
  var reset = function reset() {
    setMobile("91");
    setCountry(defaultCountry);
    setIsValid(false);
    setIsInternationalCustomer(false);
    setInputFocused(false);
    setIsTouched(false);
    if (onMobileChange) {
      onMobileChange("91");
    }
  };
  var getLength = function getLength(country) {
    switch (country) {
      case "Kuwait":
        return 11;
      case "Malaysia":
        return 9;
      case "Oman":
        return 11;
      case "Qatar":
        return 11;
      case "Saudi Arabia":
        return 12;
      case "United Arab Emirates":
        return 12;
      case "Thailand":
        return 10;
      case "Indonesia":
        return 13;
      case "India":
        return 12;
      case "United States":
        return 11;
      case "Hong Kong":
        return 11;
      case "Singapore":
        return 10;
      case "United Kingdom":
        return 12;
      default:
        return null;
    }
  };
  var validator = function validator(value, countryInValidator) {
    var len = getLength(countryInValidator === null || countryInValidator === void 0 ? void 0 : countryInValidator.name);
    if (!value) {
      setIsValid(false);
      return true;
    }
    if (!len) {
      setIsValid(true);
      return true;
    }
    if (value.startsWith(countryInValidator.dialCode) && value.length === len) {
      setIsValid(true);
      return true;
    }
    if (isTouched) {
      setIsValid(false);
      return false;
    }
    return true;
  };
  var state = {
    mobile: mobile,
    mobileHasError: mobileHasError,
    isValid: isValid,
    country: country,
    isTouched: isTouched,
    isInputFocused: isInputFocused,
    isInternationalCustomer: isInternationalCustomer
  };
  return {
    state: state,
    onChange: onChange,
    getMobileWithoutCountryCode: getMobileWithoutCountryCode,
    setIsTouched: setIsTouched,
    validator: validator,
    setMobile: setMobile,
    setInputFocused: setInputFocused,
    setIsInternationalCustomer: setIsInternationalCustomer,
    reset: reset,
    setCountry: setCountry
  };
};
export default usePhoneInput;